import { NavConfig } from './base'
import { Brand } from '../../../types/brand'
import { resolveUsMainMsal } from '../../../config/na-msal-by-identity'
import { LOYALTY_POINTS_URL } from '../../../config/paths'

export class UnitedStatesConfig extends NavConfig {
	constructor(brand: Brand) {
		super()
		this._brand = brand

		try {
			const msal = resolveUsMainMsal()
			this._auth = {
				tenant: msal.tenant,
				authority: msal.authority,
				policy: msal.policy,
				clientID: msal.clientID,
				authScopes: ['openid', 'profile'],
				approvedAuthorities: msal.approvedAuthorities,
			}
		} catch (e) {
			console.error('Error switching over to production configuration in United States Headless Auth', e)
		}
	}

	protected _region = 'us'
	protected _language = 'en'

	_urls = {
		MyAccountProfileURL: '/api/_gbpe/v3/profiles',
		MyAccountRewardsURL: LOYALTY_POINTS_URL,
		rewardsUseLoyaltyHeaders: true,
		MyAccountVehicleURL: '/ownercenter/api/garagesummary',
		MyAccountMissingInfoURL: '',
		NotificationInboxURL: '/notif/delivery/inbox/v1/customer',
		logoutURL: location.origin,
	}
}
